import { render, staticRenderFns } from "./PerformanceAgainstPreviousYears.vue?vue&type=template&id=07b095e4"
import script from "./PerformanceAgainstPreviousYears.vue?vue&type=script&lang=js"
export * from "./PerformanceAgainstPreviousYears.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports